// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import Home from '../view/home.vue'
import Project from '../view/project.vue'
import TechStack from '../view/techStack.vue'
import Contact from '../view/contact.vue'

// Lightweight placeholder so /graphics is a real URL without
 // swapping the heavy portfolio through router-view (avoids Vue parentNode crash).
const GraphicsRoute = { name: 'GraphicsRoute', render: () => null }

const routes = [
  { path: '/', name: 'Home', component: Home },
  { path: '/projects', name: 'Projects', component: Project },
  { path: '/tech-stack', name: 'TechStack', component: TechStack },
  { path: '/contact', name: 'Contact', component: Contact },
  { path: '/graphics', name: 'Graphics', component: GraphicsRoute }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  }
})

export default router
